const state = {
    urlPrefixes: {
        urlPrefix: 'https://',
        facebookUrlPrefix: 'https://www.facebook.com/',
        instagramUrlPrefix: 'https://www.instagram.com/',
        linkedinUrlPrefix: 'https://www.linkedin.com/',
        twitterUrlPrefix: 'https://twitter.com/',
        youtubeurlPrefix: 'https://www.youtube.com/',
        linkWithPappyonUrlPrefix: 'https://linkwith.pappyon.com/',
    },
};

const getters = {
    urlPrefixes: (state) => state.urlPrefixes,
};

const actions = {};

const mutations = {};

export default {
    state,
    getters,
    actions,
    mutations
}